module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/event-badge-14861aa94735fcf2fb379058d85c09e5.svg";